import React, {Component} from "react";
import { observer, inject } from "mobx-react";
import {computed, observable} from "mobx";

import { Grid } from "@material-ui/core";
import { IValuesStore } from "@src/Stores/Values/types";
import { IAuthStore } from "@src/Stores/Auth/types";
import ItemApps from "./ItemApps/ItemApps";
import { Values } from "@src/Tools/Values";
import { Application } from "@src/Interfaces/Entity/ApplicationLink";
import {
  STGrid,
  STGridOther,
  STGridButton
} from "./styles";

export interface IProps {
  sameApp?: boolean;
  values?: IValuesStore;
  auth?: IAuthStore;
}

@inject("values")
@observer
export default class ComponentApps extends Component<IProps> {
  @observable isOtherApplication: boolean = false;
  @observable applications: Application[] = [];
  @observable clientWidth: number;

  @computed get isMobileDevice() {
    return this.clientWidth <= parseInt(this.props.values.common.MobileDeviceWidth);
  }
  
  async componentDidMount() {
    var url = new URL(window.location.href);
    var applicationId = url.searchParams.get("applicationToSkip");
    this.clientWidth = parseInt(url.searchParams.get("clientWidth"));
      this.applications = await this.props.values.getApplications(applicationId ? Number(applicationId) : null);
  }

  render() {
    const generalApplication = this.applications.slice(0,12);
    const otherApplication = this.applications.slice(12);
    return (
      <Grid container direction="column">
        <STGrid container component="ul">
          {generalApplication.map((item : Application, index: Number)=> 
            ((this.isMobileDevice && item.mobile) || (!this.isMobileDevice && item.desktop)) 
              && <ItemApps {...item} key = {String(index)} sameApp={this.props.sameApp} />
          )}
        </STGrid>
        {this.getOtherBlock(otherApplication)}
      </Grid>
    );
  }

  getOtherBlock = (otherApplication: Application[]) => {
    if(otherApplication.length > 0){
      if(this.isOtherApplication){
        return(
            <STGridOther container component="ul">
              {otherApplication.map((item : Application, index: Number)=>
                ((this.isMobileDevice && item.mobile) || (!this.isMobileDevice && item.desktop)) 
                  && <ItemApps {...item} key = {String(index)} />
              )}
            </STGridOther>
          )
      } else {
        return(
          <STGridButton onClick={()=>this.isOtherApplication = !this.isOtherApplication} >
            {Values.getLocalizationValue("more")}
          </STGridButton>
        )
      }
    }
  }

  handleClickOtherApps = () => {
    this.isOtherApplication = !this.isOtherApplication;
  };
}
